module.exports = __webpack_public_path__ + "img/VE.bad5f73b.svg";